import React from "react"
import { Link, useI18next, useTranslation } from "gatsby-plugin-react-i18next"
import { List } from "./styles"

const ToggleLanguage = () => {
  const { language, languages, originalPath } = useI18next()
  const { t } = useTranslation()
  return (
    <List aria-label={t("language_switch")}>
      {languages.map(lng => (
        <li key={lng}>
          <Link
            to={originalPath}
            language={lng}
            lang={lng}
            hrefLang={lng}
            aria-current={language === lng ? "true" : undefined}
            className={language === lng ? "active" : undefined}
          >
            {lng.toUpperCase()}
            <span className="sr-only"> – {t(`lang_${lng}`)}</span>
          </Link>
        </li>
      ))}
    </List>
  )
}

export default ToggleLanguage
